// components/SparkleCursor.jsx
import React, { useEffect } from 'react';

const SparkleCursor = () => {
  useEffect(() => {
    const createSparkle = (e) => {
      const sparkle = document.createElement('div');
      sparkle.className = 'global-sparkle';
      sparkle.style.left = `${e.clientX}px`;
      sparkle.style.top = `${e.clientY}px`;
      document.body.appendChild(sparkle);

      setTimeout(() => {
        sparkle.remove();
      }, 1000);
    };

    document.addEventListener('mousemove', createSparkle);
    return () => document.removeEventListener('mousemove', createSparkle);
  }, []);

  return null;
};

export default SparkleCursor;
